import { useGrowlStoreActions } from "PFApp/stores/growl_store";
import { Modal } from "PFComponents/modal";
import { Typography } from "PFComponents/typography";
import { useResponseErrors } from "PFCore/helpers/use_response_errors";
import { useCertificateDelete } from "PFCore/hooks/queries/certificates";
import { Certificate } from "PFTypes/certificate";
import { useTranslation } from "react-i18next";

import css from "./delete_certificate_modal.module.scss";

type DeleteCertificateModalProps = {
  certificate: Certificate;
  onClose: () => void;
  onDeleted: () => void;
};

const DeleteCertificateModal = ({ certificate, onClose, onDeleted }: DeleteCertificateModalProps) => {
  const { showGrowl } = useGrowlStoreActions();
  const { t } = useTranslation(["profiles", "translation"]);
  const { getFirstError } = useResponseErrors();

  const updateCertificateMutation = useCertificateDelete({
    id: certificate.id,
    onError: (response) => {
      const error = getFirstError(response);
      showGrowl({
        message: error || t("translation:somethingWentWrong"),
        kind: "error"
      });
    },
    onSuccess: () => {
      showGrowl({ kind: "success", message: t("profiles:common.certificates.growl.deleted") });
      onDeleted();
    }
  });

  return (
    <Modal
      title={`${t("profiles:common.certificates.deleteCertificate")}?`}
      labelOK={t("translation:deleteText")}
      onOK={() => updateCertificateMutation.mutate(certificate.id)}
      onClose={onClose}
      kindOK="danger"
    >
      <Typography variant="bodyRegular" className={css.certificateTitle}>
        {certificate.title}
      </Typography>
    </Modal>
  );
};

export default DeleteCertificateModal;
